export default __webpack_public_path__ + "static/media/group_2021.edd6932c.png";